export enum WidgetTypeEnum {
	Notifications = 0,
	Messages = 1,
	FdaRecalls = 2,
	RxRefillRequest = 3,
	SysInvShortcuts = 4,
	RxSearch = 5,
	SupportTicket = 6,
	OrganizationQuickNav = 7,
	SysInvCycleCounts = 8,
	ExpiringMedications = 9,
	NDCLookup = 10,
	InsulinRequiresReview = 11,
	InsulinAwaitingRx = 12,
	InsulinQueueSummary = 13,
	IssuanceQuickScan = 14
}

export namespace WidgetTypeEnum {
	export function toDescription(val: WidgetTypeEnum) {
		switch (val) {
			case 0:
				return "Notifications";
			case 1:
				return "Messages";
			case 2:
				return "FDA Recalls";
			case 3:
				return "Rx Refill Request";
			case 4:
				return "Sys Inv Shortcuts";
			case 5:
				return "Rx Search";
			case 6:
				return "Support Ticket";
			case 7:
				return "Organization Quick Nav";
			case 8:
				return "Inventory Cycle Counts";
			case 9:
				return "Expiring Medications";
			case 10:
				return "NDC Lookup";
			case 11:
				return "Insulin Requires Review";
			case 12:
				return "Insulin Awaiting Rx Association";
			case 13:
				return "Insulin Queue Summary";
			case 14:
				return "Issuance Quick Scan";
		}
		return null;
	}
	export function toDisplay(val: WidgetTypeEnum) {
		switch (val) {
			case 0:
				return "Notifications";
			case 1:
				return "Messages";
			case 2:
				return "FdaRecalls";
			case 3:
				return "RxRefillRequest";
			case 4:
				return "SysInvShortcuts";
			case 5:
				return "RxSearch";
			case 6:
				return "SupportTicket";
			case 7:
				return "OrganizationQuickNav";
			case 8:
				return "SysInvCycleCounts";
			case 9:
				return "ExpiringMedications";
			case 10:
				return "NDCLookup";
			case 11:
				return "InsulinRequiresReview";
			case 12:
				return "InsulinAwaitingRx";
			case 13:
				return "InsulinQueueSummary";
			case 14:
				return "IssuanceQuickScan";
		}
		return null;
	}
}
